import { FC } from 'react';

import cs from 'classnames';

import getUserTimeZone from 'components/InterviewScheduler/utils/getUserTimeZone';

import { useTranslation } from 'react-i18next';
import styles from './JobseekerTimezoneLabel.module.scss';

interface JobseekerTimezoneLabelProps {
  className?: string;
}

const JobseekerTimezoneLabel: FC<JobseekerTimezoneLabelProps> = ({
  className
}) => {
  const { t } =useTranslation()
  const userTimezone = getUserTimeZone();

  return (
    <div className={cs(styles.timezoneContainer, className)}>
      <span className={styles.utcLabel}>{userTimezone}</span>
      <div>{t('interviewScheduler.timeZone')}</div>
    </div>
  );
};

export default JobseekerTimezoneLabel;
